import Api from "./Api";

const endpoint = "/notenverwaltung/transfer/sv";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.show = params.show;

        return Api.fetchData(endpoint, usedParams);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    getTransactions(sv_id, noten_id, werk_id, notentyp) {
        return Api.fetchData(
            endpoint +
                "/" +
                sv_id +
                "/transactions/note/" +
                noten_id +
                "/werk/" +
                werk_id +
                "/notentyp/" +
                notentyp
        );
    },
    getTransactionsForConcert(sv_id, werk_id) {
        return Api.fetchData(
            endpoint + "/" + sv_id + "/transactions/werk/" + werk_id
        );
    },
    getRecordsForSV(sv_id) {
        return Api.fetchData(endpoint + "/" + sv_id + "/records/issued");
    },
    getWerkeForSV(sv_id) {
        return Api.fetchData(endpoint + "/" + sv_id + "/werke/issued");
    },
    cancelTransaction(id) {
        return Api.deleteData(endpoint + "/transaction/" + id + "/cancel");
    },
    getReceipt(id) {
        return Api.fetchData(endpoint + "/transaction/" + id + "/receipt");
    }
};
